import {gsap, SplitText} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Split {
	static init() {
		this.items = document.querySelectorAll("[data-split-chars]");
		this.build();
		GlobalVariables.resizeCallbacks.push(this);
	}

	static build(){

		this.splitTexts= [];

		this.items.forEach(elem => {
			const innerSplit = new SplitText(elem, {
				type: "words, chars",
				wordsClass: "split-words",
				charsClass: "split-chars"
			});

			const splitTimeline = gsap.timeline().pause();

			splitTimeline.to(innerSplit.chars, {
				duration: 0.3,
				yPercent: -20,
				ease: "power1.ease",
				stagger: 0.02
			});

			elem.addEventListener('mouseenter', () => {
				splitTimeline.play();
			});

			elem.addEventListener('mouseleave', () => {
				splitTimeline.reverse();
			});

			this.splitTexts.push(innerSplit);
		});


	}

	static resize() {
		this.splitTexts.forEach(item => {
			item.revert();
		});
		this.build();
	}
}
